<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import { variantFields } from "../../_shared/_logic/draft"
  import type { LetterDraft, LetterTemplateVariant } from "../../_shared/_logic/letter-types"
  import {
    letterTemplateTokens,
    letterRescheduleTemplateTokens,
    letterSubtitleTemplateTokens,
    letterPortalHeadingTemplateTokens,
  } from "../../../../_shared/_logic/templates"

  let {
    draft = $bindable(),
    variant,
    disabled,
  }: { draft: LetterDraft; variant: LetterTemplateVariant; disabled: boolean } = $props()
  const labels = [
    "Titel",
    "Untertitel",
    "Brieftext Einleitung",
    "Brieftext Aufforderung",
    "Text beim QR-Code",
  ]
</script>

<section aria-label="Briefinhalt" class="form letter-form">
  {#each variantFields(variant) as field, index}
    <Input
      type={index === 0 ? "text" : variant === "aushang" ? "textarea" : "tagbased_input"}
      placeholder={labels[index]}
      bind:value={draft[field]}
      brightBackground={true}
      {disabled}
      tokenSyntax="single"
      options={index === 1
        ? letterSubtitleTemplateTokens
        : index === 3
          ? letterPortalHeadingTemplateTokens
          : variant === "reschedule"
            ? letterRescheduleTemplateTokens
            : letterTemplateTokens}
    />
  {/each}
</section>

<style>
  .letter-form {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 1rem;
    min-width: 0;
    height: auto;
    color: var(--text-invers-100);
  }
  .letter-form :global(textarea) {
    font-family: inherit;
    line-height: 1.5;
    min-height: 7rem;
  }
  .letter-form :global(label.tagBasedInput .tag-input-shell.brightBackground .text-segment),
  .letter-form :global(label.tagBasedInput .tag-input-shell.brightBackground .token__tag),
  .letter-form :global(label.tagBasedInput .tag-editor.brightBackground) {
    color: var(--text-invers-100);
    caret-color: var(--text-invers-100);
  }
</style>
